import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChecklist = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.5 3.75C3.5 3.61193 3.61193 3.5 3.75 3.5H17.25C17.3881 3.5 17.5 3.61193 17.5 3.75V13.75C17.5 14.1642 17.8358 14.5 18.25 14.5C18.6642 14.5 19 14.1642 19 13.75V3.75C19 2.7835 18.2165 2 17.25 2H3.75C2.7835 2 2 2.7835 2 3.75V20.25C2 21.2165 2.7835 22 3.75 22H10.75C11.1642 22 11.5 21.6642 11.5 21.25C11.5 20.8358 11.1642 20.5 10.75 20.5H3.75C3.61193 20.5 3.5 20.3881 3.5 20.25V3.75Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.25 7C5.83579 7 5.5 7.33579 5.5 7.75C5.5 8.16421 5.83579 8.5 6.25 8.5H14.75C15.1642 8.5 15.5 8.16421 15.5 7.75C15.5 7.33579 15.1642 7 14.75 7H6.25Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 11.75C5.5 11.3358 5.83579 11 6.25 11H10.75C11.1642 11 11.5 11.3358 11.5 11.75C11.5 12.1642 11.1642 12.5 10.75 12.5H6.25C5.83579 12.5 5.5 12.1642 5.5 11.75Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.7803 16.2803C22.0732 15.9874 22.0732 15.5126 21.7803 15.2197C21.4874 14.9268 21.0126 14.9268 20.7197 15.2197L15.75 20.1893L13.7803 18.2197C13.4874 17.9268 13.0126 17.9268 12.7197 18.2197C12.4268 18.5126 12.4268 18.9874 12.7197 19.2803L15.2197 21.7803C15.5126 22.0732 15.9874 22.0732 16.2803 21.7803L21.7803 16.2803Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgChecklist;
